var FriendPvpRedirector = xClass("FriendPvpRedirector", BaseRedirector)
FriendPvpRedirector.prototype.getName = function () {
    return "friend_pvp"
}
FriendPvpRedirector.prototype.redirect = function () {
    cc.log("----FriendPvpRedirector redirect----")
    var self = this
    var param = self.param

    var scene = cc.Director.getInstance().getRunningScene()
    if (!scene || scene.name === 'PreloadScene') {
        return false
    } else if (scene && scene.name === "HomeScene") {
        let logic = require("activity/PvpActivity/FriendPvpActivityLogic").getInstance()
        let um = UserManager.getInstance()
        if (!logic.isSupport()) {
            Toast.make('您的设备不支持好友对战哦~')
            return true
        } else if (!um.getSettingByKey('friendPvpOpen')) {
            Toast.make('很遗憾，友谊赛活动已经结束了哦~')
            return true
        } else {
            let roomid = param.roomid
            let inviteCode = param.inviteCode
            let inviteCodeFlag = !inviteCode || (parseInt(inviteCode) !== UserManager.getInstance().uid)
            let lastPanel = PopoutManager.getLastPopoutPanel()
            let lastPanelFlag = !lastPanel || (lastPanel && lastPanel.class.__cname !== "FriendPvpActivityMatchPanel")
            cc.log("roomid",roomid,"inviteCodeFlag",inviteCodeFlag);
            if (!lastPanelFlag){
                Toast.make(getText("pvp.friends.joinfailed1"));
                return true
            }
            lastPanelFlag = !lastPanel || (lastPanel && lastPanel.class.__cname !== "PvpActiviyPanel")
            if (!lastPanelFlag){
                Toast.make(getText("要先退出好友竞技"));
                return true
            }

            lastPanelFlag = !lastPanel || (lastPanel && lastPanel.class.__cname !== "StartPanel"
                                                     && lastPanel.class.__cname !== "FriendPvpActivityMatchPanel")
            if (!lastPanelFlag){
                cc.log("start panel is showing");
                return true
            }
            if (roomid && inviteCodeFlag && lastPanelFlag) {
                return new Promise(resolve => {
                    CfgManager.load("friend_pvp")
                    .then((data) => {
                        var config = data.get("friend_pvp");
                        var validTime = config.pvp_share_validity;
                        var dt = Localhost.timeInSec() - param.time;
                        cc.log("----FriendPvpRedirector---")
                        cc.log(dt, validTime)
                        if (dt > validTime){
                            resolve();
                            Toast.make(getText("pvp.help.failed04"));
                            return
                        }
                        var pvpLogic = require("activity/PvpActivity/FriendPvpActivityLogic");
                        pvpLogic = pvpLogic.getInstance();
                        var onSuccess = function(evt){
                            pvpLogic.pvpManager.setActivityInfo(evt.data);
                            var activityInfo = pvpLogic.pvpManager.getActivityInfo();
                            if ((activityInfo.freeCount + activityInfo.adTicketCount) <= 0){
                                resolve();
                                Toast.make(getText("pvp.help.failed01"));
                            }else{
                                self.checkHelpTimes(pvpLogic, param, resolve);
                            }
                        }
                        var onFail = function(evt){
                            resolve();
                            cc.error(evt);
                        }
                        var http = GetPvpInfoHttp.new();
                        http.addEventListener(Events.kComplete, onSuccess);
                        http.addEventListener(Events.kError, onFail);
                        http.addEventListener(Events.kCancel, onFail);
                        http.load();
                    })
                });
            } else {
                return true
            }
        }
    } else {
        Toast.make(getText("pvp.friends.joinfailed2"));
        return true
    }
}

FriendPvpRedirector.prototype.checkHelpTimes = function(logic, param, resolve){
    var onSuccess = function(evt){
        if (evt.data.leftHelpCnt <= 0){
            resolve();
            Toast.make(getText("error.tip.761308"));
            return;
        }
        if (evt.data.leftHelpTotal <= 0){
            resolve();
            Toast.make(getText("error.tip.761307"));
            return;
        }
        logic.showMatchPanel(param, null, resolve);
    }
    var onFail = function(evt){
        resolve();
        Toast.make(getText("error.tip." + tostring(evt.data)));
    }
    var http = FriendPvpInviteinfoHttp.new(param.inviteCode);
    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);
    http.load();
}

module.exports = FriendPvpRedirector